export default "__VITE_ASSET__DLBPcQAJ__"